export default class BackToTopService {
    constructor() {
        this.button = null;
    }
    createButton() {
        this.button = document.createElement('div');
        this.button.className = 'back-to-top';
        this.button.innerHTML = '<div class="arrow"></div>';
        document.body.appendChild(this.button);
        this.button.addEventListener('click', () => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        });
        window.addEventListener('scroll', () => this.toggleButton());
    }
    toggleButton() {
        if (!this.button)
            return;
        if (window.scrollY > 300) {
            this.button.classList.add('show');
        }
        else {
            this.button.classList.remove('show');
        }
    }
    init() {
        this.createButton();
    }
}
